import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ModernNavbar from './components/ModernNavbar';
import ModernFooter from './components/ModernFooter';
import ModernHomePage from './pages/ModernHomePage';
import FixedUnitPage from './pages/FixedUnitPage';
import NotesPage from './pages/NotesPage';
import PastPapersPage from './pages/PastPapersPage';
import AboutPage from './pages/AboutPage';
import InfoPage from './pages/InfoPage';
import MigrationModal from './components/MigrationModal';
import MigrationBanner from './components/MigrationBanner';
import './App.css';

function MigrationController({ setShowModal, setShowBanner }) {
  const location = useLocation();

  useEffect(() => {
    const isHomePage = location.pathname === '/' || location.pathname.startsWith('/semester/');
    const bannerDismissed = localStorage.getItem('cova_migration_banner_dismissed') === 'true';

    if (isHomePage) {
      setShowModal(true);
      setShowBanner(false);
    } else {
      setShowModal(false);
      if (!bannerDismissed) {
        setShowBanner(true);
      } else {
        setShowBanner(false);
      }
    }
  }, [location, setShowModal, setShowBanner]);

  return null;
}

function App() {
  const [showModal, setShowModal] = useState(false);
  const [showBanner, setShowBanner] = useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
    
    // Check if the banner was already dismissed to avoid showing it again
    const bannerDismissed = localStorage.getItem('cova_migration_banner_dismissed') === 'true';
    if (!bannerDismissed) {
      setShowBanner(true);
    }
  };

  const handleCloseBanner = () => {
    localStorage.setItem('cova_migration_banner_dismissed', 'true');
    setShowBanner(false);
  };

  return (
    <Router>
      <div className="app">
        <MigrationController setShowModal={setShowModal} setShowBanner={setShowBanner} />
        <MigrationBanner isVisible={showBanner} onClose={handleCloseBanner} />
        <ModernNavbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<ModernHomePage />} />
            <Route path="/semester/:semesterId" element={<ModernHomePage />} />
            <Route path="/unit/:unitName" element={<FixedUnitPage />} />
            <Route path="/unit/:unitName/notes" element={<NotesPage />} />
            <Route path="/unit/:unitName/past-papers" element={<PastPapersPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/info" element={<InfoPage />} />
          </Routes>
        </main>
        <MigrationModal isOpen={showModal} onClose={handleCloseModal} />
        <ModernFooter />
      </div>
    </Router>
  );
}

export default App;

